export const UserAndRollColumns = [
    {
        Header: "Name",
        accessor: "name",
    },
    {
        Header: "Action",
        accessor: "action",
    },
]
export const UserAndRollTableData = [
    {
        Id: 0,
        name: "Accounts"
    },
    {
        Id: 2,
        name: "Ava Walker"
    },
    {
        Id: 3,
        name: "Christopher Harris"
    },
    {
        Id: 4,
        name: "Credit Cards"
    },
    {
        Id: 5,
        name: "Daniel Martinez"
    },
    {
        Id: 6,
        name: "Dashboard"
    },
    {
        Id: 7,
        name: "Emma Taylor"
    },
    {
        Id: 8,
        name: "Investments"
    },
    {
        Id: 9,
        name: "James Anderson"
    },
    {
        Id: 10,
        name: "Lons"
    },
    {
        Id: 11,
        name: "Olivia Clark"
    },
    {
        Id: 12,
        name: "Service"
    },
    {
        Id: 13,
        name: "Setting"
    },
    {
        Id: 14,
        name: "Transaction"
    },
]
